<template>
  <component :is="layout">
    <router-view/>
  </component>

</template>

<script>

export default {
  computed: {
    layout() {
      if(!(localStorage.getItem("loggedin") == null)){
        return `${this.$route.meta.layout || 'default'}-layout`;
      }
      return `${this.$route.meta.layout || 'login'}-layout`;
    },
  },
  data(){
    return {
      VUE_APP_SERVICE_URL: process.env.VUE_APP_SERVICE_URL,
      VUE_APP_API: process.env.VUE_APP_API
    }
  },
  methods:{
    
  }
};
</script>
